export default{
  createFields: {
    name: {
      type: 'text',
      title: '名稱',
      placeholder: '輸入',
      rules: 'required',
      required: true,
    },
    sequence: {
      type: 'text',
      title: '排序',
      placeholder: '輸入',
    },
  },
  updateFields: {
    name: {
      type: 'text',
      title: '名稱',
      placeholder: '輸入',
      rules: 'required',
      required: true,
      getValueKey: 'text',
    },
    sequence: {
      type: 'text',
      title: '排序',
      placeholder: '輸入',
      getValueKey: 'sequence'
    },
  },
}